import login from './en/login_page'
import home from './en/home_page'
import server from './en/server_page'
import pipeline from './en/pipeline'
import settings from './en/settings_page'
import reports from './en/reports_page'
import lists from './en/lists'
import dashboards from './en/dashboards'
import ui_settings from './en/ui_settings'

import columns from './en/columns'

import menu from './en/menu_list'
import button from './en/buttons'
import notification from './en/notifications'
import confirm from './en/confirm'
import { placeholder, word, error, title } from './en/other'

export default {
  login,
  home,
  server,
  pipeline,
  settings,
  reports,
  menu,
  button,
  notification,
  confirm,
  lists,
  columns,
  dashboards,
  ui_settings,
  placeholder,
  word,
  error,
  title,

  password: 'Password',
  name: 'Name',
  role: 'Role'
}
